/**************************************************
 * Nombre:       Pdf_Certificado_Consultor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Document, Font, Image, Page, StyleSheet, Text, View} from '@react-pdf/renderer';
import f500 from './Recursos/ImperialScript-Regular.ttf'
import f600 from './Recursos/JosefinSans-Bold.ttf'
import fondo from './Recursos/certificado_consultor.png'
import {primerasLetrasMayusculas} from "../../Utilidades/primerasLetrasMayusculas";


const Pdf_Certificado_Consultor = ({usuario, capacitacion}) => {
    Font.register({family: '500', src: f500})
    Font.register({family: '600', src: f600})


    const styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            backgroundColor: '#ffffff00',
            padding: 0,
        },
        columna: {
            justifyContent: 'flex-start',
            flexDirection: 'column',
            width: '100%',
        },
        git: {
            justifyContent: 'flex-start',
            flexDirection: 'row',
            width: '100%'
        },
        textoGT: {
            fontSize: 60,
            fontFamily: '500',
            lineHeight: 1.1
        },
        textoT: {
            fontSize: 36,
            fontFamily: '600',
            lineHeight: 1.1,
            color: '#B0864F'
        }


    });


    return (
        <Document>
            <Page size={[1100, 778]} style={styles.page}>

                <View style={styles.columna}>

                    <View style={{...styles.git, width: '100%'}}>
                        <Image src={fondo} style={{width: '100%', height: 'auto', position: 'relative', zIndex: 1}}/>
                    </View>

                    <View style={{...styles.git, marginTop: -435, width: '100%', justifyContent: 'center'}}>
                        <Text style={{
                            ...styles.textoGT,
                            textAlign: 'center'
                        }}>{usuario && primerasLetrasMayusculas(usuario.nombres + ' ' + usuario.apellidos)}</Text>
                    </View>

                    <View style={{...styles.git, marginTop: 100, width: '100%', justifyContent: 'center'}}>
                        <Text style={{
                            ...styles.textoT,
                            textAlign: 'center'
                        }}>{capacitacion && capacitacion.titulo && capacitacion.titulo}</Text>
                    </View>

                </View>


            </Page>
        </Document>
    )

}
export default Pdf_Certificado_Consultor